exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?minimize!../node_modules/bootstrap/dist/css/bootstrap.min.css"), "");

// module
exports.push([module.id, "\n.uh-header {\n  padding: 20px 0px;\n  text-align: center;\n}\n.uh-login {\n  padding: 20px 0px;\n}\n.uh-portal {\n  padding: 5px 15px;\n}\n.uh-footer {\n  padding: 20px 5px 10px 5px;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71ec7560","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 24
// module chunks = 0